<template>
  <q-dialog v-model="edit" persistent>
    <q-scroll-area :visible="true" style="height: 100%; max-width: 600px; width: 100%">
      <q-card style="height:100%; max-width: 600px; width: 100%">
        <q-tabs
          v-model="tab"
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
        >
          <q-tab name="edit" label="Vehicle Edit" />
          <q-tab name="dollars" label="Finance Data" />
        </q-tabs>
        <q-tab-panels v-model="tab">
          <q-tab-panel name="edit">
            <q-form @submit="onSubmit" ref="myForm" class="flexbox">
              <div class="q-pa-md">
                <div class="row q-col-gutter-md">
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Company Name*</span>
                    <q-select
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      :options="companies"
                      :rules="[val => !!val.id || 'Please select your company']"
                      :option-label="company => company.name"
                      :option-value="company => company.id"
                      v-model="company"
                      hide-bottom-space
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template>
                      <template v-slot:prepend>
                        <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Location Name*</span>
                    <q-select
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      :disable="!company.id"
                      label-color="grey-7"
                      lazy-rules
                      :options="locations"
                      :rules="[val => !!val.id || 'Please select your location']"
                      :option-label="location => location.name"
                      :option-value="location => location.id"
                      v-model="location"
                      hide-bottom-space
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template>
                      <template v-slot:prepend>
                        <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <div class="label-input">VIN NUMBER*</div>
                    <q-input
                      @change="handleVin"
                      :disable="!location.id"
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      :rules="[
                        val => (val !== null && val !== '' && val.length === 17) || 'Please type 17 chars VIN number.'
                      ]"
                      v-model="vin"
                      hide-bottom-space
                    >
                      <template v-slot:prepend>
                        <q-icon name="fas fa-fingerprint" size="15px" color="grey-7"></q-icon>
                      </template>
                    </q-input>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Year*</span>
                    <q-input
                      type="number"
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      @change="yearChangeHandler"
                      label-color="grey-7"
                      lazy-rules
                      v-model="modelYear"
                      :rules="[
                        val =>
                          val === null ||
                          val === '' ||
                          (val > 2000 && val <= new Date().getFullYear() + 2) ||
                          `Vehicle register date min bigger than 2000 and less than ${new Date().getFullYear() + 2}`
                      ]"
                    ></q-input>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <div class="label-input">UNIT NUMBER*</div>
                    <q-input
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      :rules="[val => (val !== null && val !== '') || 'Please type UNIT number.']"
                      v-model="unit"
                      hide-bottom-space
                    >
                      <template v-slot:prepend>
                        <q-icon name="fas fa-cogs" size="15px" color="grey-7"></q-icon>
                      </template>
                    </q-input>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Brand*</span>
                    <q-select
                      :disable="!modelYear"
                      class="customTextColor"
                      outlined
                      @input="brandChangeHandler"
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      :options="brands"
                      v-model="brand"
                      hide-bottom-space
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template>
                      <template v-slot:prepend>
                        <q-icon name="fas fa-car" size="16px" color="grey-7"></q-icon>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Model</span>
                    <q-select
                      :disable="!brand"
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      @input="modelChangeHandler"
                      lazy-rules
                      :options="models"
                      v-model="model"
                      ><template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template></q-select
                    >
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Model Detail</span>
                    <q-select
                      :disable="!model"
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      :options="modelDetails"
                      v-model="modelDetail"
                      ><template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template></q-select
                    >
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6" style="position: relative">
                    <span class="label-input">Class</span>
                    <q-select
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      :options="classes"
                      v-model="selectedClass"
                      ><template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template></q-select>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Color</span>
                    <q-input
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      v-model="color"
                      hide-bottom-space
                    ></q-input>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Custom Tag</span>
                    <q-select
                      outlined
                      class="customTextColor"
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      multiple
                      :options="tags"
                      :option-label="tag => tag.name"
                      :option-value="tag => tag.id"
                      v-model="localTags"
                      hide-bottom-space
                      ><template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template></q-select
                    >
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Condition</span>
                    <q-select
                      outlined
                      class="customTextColor"
                      color="grey-7"
                      label-color="grey-7"
                      :options="conditions"
                      :option-label="cond => cond.name"
                      :option-value="cond => cond.val"
                      v-model="condition"
                      hide-bottom-space>
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Mileage*</span>
                    <q-input
                      :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Mileage value.']"
                      type="number"
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      label-color="grey-7"
                      lazy-rules
                      v-model="mileage"
                    ></q-input>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">In Service Date*</span>
                    <q-input
                      dense
                      class="customTextColor"
                      outlined
                      color="grey-7"
                      hide-bottom-space
                      label-color="grey-7"
                      v-model="in_service_date"
                      mask="##/##/####"
                      lazy-rules
                      :rules="[val => (val && val.length > 0) || 'Invalid type In Service Date']"
                    >
                      <template v-slot:append>
                        <q-icon name="fas fa-calendar" class="cursor-pointer">
                          <q-popup-proxy ref="qDateProxy1" transition-show="scale" transition-hide="scale">
                            <q-date v-model="in_service_date" mask="MM/DD/YYYY">
                              <div class="row items-center justify-end">
                                <q-btn v-close-popup label="Close" color="primary" flat />
                              </div>
                            </q-date>
                          </q-popup-proxy>
                        </q-icon>
                      </template>
                    </q-input>
                  </div>
                  <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                    <span class="label-input">Status</span>
                    <q-select
                      outlined
                      class="customTextColor"
                      color="grey-7"
                      label-color="grey-7"
                      :options="statuses()"
                      :option-label="status => status.label"
                      :option-value="status => status.value"
                      v-model="status"
                      hide-bottom-space>
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-italic text-grey">
                            There is no options.
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-12">
                    <div class="mt-5 flex-end q-gutter-xs">
                      <q-btn color="grey-7" @click="abort">CANCEL</q-btn>
                      <q-btn
                        :loading="financeLoading"
                        :disable="financeLoading"
                        label="Save"
                        type="submit"
                        color="positive"
                      >
                        <template v-slot:loading>
                          <q-spinner-facebook />
                        </template>
                      </q-btn>
                    </div>
                  </div>
                </div>
              </div>
            </q-form>
          </q-tab-panel>
          <q-tab-panel name="dollars">
            <q-select
              label="Type"
              :disable="financeLoading"
              square
              filled
              v-model="selectedFinanceFilter"
              :options="financeFilters"
              :option-label="option => option.label"
              :option-value="option => option.value"
            />
            <q-form
              v-if="selectedFinanceFilter.value === 'lease_one'"
              @submit="onSubmitLeaseOne"
              ref="leaseOne"
              class="flexbox"
            >
              <div class="row q-col-gutter-md" style="margin-top: 10px">
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Purchase Amount</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="leaseOne.purchase_amount"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Purchase Amount.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Period</span>
                  <q-input
                    dense
                    type="number"
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="leaseOne.length"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Period.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Depreciation Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    step="0.1"
                    lazy-rules
                    v-model.number="leaseOne.monthly_depreciation"
                    :rules="[val => val > 0 || val === null || val === '' || 'Invalid type Monthly Depreciation']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Interest Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="leaseOne.monthly_payment"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type monthly interest.',
                      val => val >= 0 || 'Invalid type Monthly Interest'
                    ]"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Source</span>
                  <q-select
                    :disable="financeLoading"
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    dense
                    v-model="leaseOne.financing_company"
                    :options="financeCompanies"
                    :option-label="option => option.name"
                    :option-value="option => option.id"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Term</span>
                  <q-input
                    dense
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model="leaseOne.term"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Start Date</span>
                  <q-input
                    dense
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    v-model="leaseOne.start_date"
                    mask="date"
                    :rules="['date' || 'Invalid type Start Date']"
                  >
                    <template v-slot:append>
                      <q-icon name="fas fa-calendar" class="cursor-pointer">
                        <q-popup-proxy ref="qDateProxy1" transition-show="scale" transition-hide="scale">
                          <q-date v-model="leaseOne.start_date">
                            <div class="row items-center justify-end">
                              <q-btn v-close-popup label="Close" color="primary" flat />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12">
                  <div class="mt-5 flex-end q-gutter-xs">
                    <q-btn color="grey-7" @click="abort">CANCEL</q-btn>
                    <q-btn :loading="loading" label="Save" type="submit" color="positive">
                      <template v-slot:loading>
                        <q-spinner-facebook />
                      </template>
                    </q-btn>
                  </div>
                </div>
              </div>
            </q-form>
            <q-form
              v-if="selectedFinanceFilter.value === 'lease_two'"
              @submit="onSubmitLeaseTwo"
              ref="leaseTwo"
              class="flexbox"
            >
              <div class="row q-col-gutter-md" style="margin-top: 10px">
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Purchase Amount</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="leaseTwo.purchase_amount"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Purchase Amount.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Period</span>
                  <q-input
                    dense
                    type="number"
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="leaseTwo.length"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Period.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Depreciation Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    step="0.1"
                    lazy-rules
                    v-model.number="leaseTwo.monthly_depreciation_rate"
                    :rules="[val => val > 0 || val === null || val === '' || 'Invalid type Monthly Depreciation Rate']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Interest Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="leaseTwo.monthly_interest_rate"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type monthly interest.',
                      val => val >= 0 || 'Invalid type Monthly Interest'
                    ]"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Source</span>
                  <q-select
                    :disable="financeLoading"
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    dense
                    v-model="leaseTwo.financing_company"
                    :options="financeCompanies"
                    :option-label="option => option.name"
                    :option-value="option => option.id"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Term</span>
                  <q-input
                    dense
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model="leaseTwo.term"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Start Date</span>
                  <q-input
                    dense
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    v-model="leaseOne.start_date"
                    mask="date"
                    :rules="['date' || 'Invalid type Start Date']"
                  >
                    <template v-slot:append>
                      <q-icon name="fas fa-calendar" class="cursor-pointer">
                        <q-popup-proxy ref="qDateProxy1" transition-show="scale" transition-hide="scale">
                          <q-date v-model="leaseOne.start_date">
                            <div class="row items-center justify-end">
                              <q-btn v-close-popup label="Close" color="primary" flat />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12">
                  <div class="mt-5 flex-end q-gutter-xs">
                    <q-btn color="grey-7" @click="abort">CANCEL</q-btn>
                    <q-btn :loading="loading" label="Save" type="submit" color="positive">
                      <template v-slot:loading>
                        <q-spinner-facebook />
                      </template>
                    </q-btn>
                  </div>
                </div>
              </div>
            </q-form>
            <q-form
              v-if="selectedFinanceFilter.value === 'loan_one'"
              @submit="onSubmitLoanOne"
              ref="loanOne"
              class="flexbox"
            >
              <div class="row q-col-gutter-md" style="margin-top: 10px">
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Purchase Amount</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanOne.purchase_amount"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Purchase Amount.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Period</span>
                  <q-input
                    dense
                    type="number"
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanOne.length"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Period.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Depreciation Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    step="0.1"
                    lazy-rules
                    v-model.number="loanOne.monthly_depreciation_rate"
                    :rules="[val => val > 0 || val === null || val === '' || 'Invalid type Monthly Depreciation Rate']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Interest Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanOne.monthly_interest_rate"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type monthly interest.',
                      val => val >= 0 || 'Invalid type Monthly Interest'
                    ]"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Down Payment</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanOne.down_payment"
                    :rules="[val => (val !== null && val !== '' && val >= 0) || 'Please type Down Payment.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Source</span>
                  <q-select
                    :disable="financeLoading"
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    dense
                    v-model="loanOne.financing_company"
                    :options="financeCompanies"
                    :option-label="option => option.name"
                    :option-value="option => option.id"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Term</span>
                  <q-input
                    dense
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model="loanOne.term"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Start Date</span>
                  <q-input
                    dense
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    v-model="leaseOne.start_date"
                    mask="date"
                    :rules="['date' || 'Invalid type Start Date']"
                  >
                    <template v-slot:append>
                      <q-icon name="fas fa-calendar" class="cursor-pointer">
                        <q-popup-proxy ref="qDateProxy1" transition-show="scale" transition-hide="scale">
                          <q-date v-model="leaseOne.start_date">
                            <div class="row items-center justify-end">
                              <q-btn v-close-popup label="Close" color="primary" flat />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div v-if="false" class="col-12">
                  <q-checkbox label="Least Payment" v-model="loanOne.is_least_payment" />
                </div>
                <div class="col-12">
                  <div class="mt-5 flex-end q-gutter-xs">
                    <q-btn color="grey-7" @click="abort">CANCEL</q-btn>
                    <q-btn :loading="loading" label="Save" type="submit" color="positive">
                      <template v-slot:loading>
                        <q-spinner-facebook />
                      </template>
                    </q-btn>
                  </div>
                </div>
              </div>
            </q-form>
            <q-form
              v-if="selectedFinanceFilter.value === 'loan_two'"
              @submit="onSubmitLoanTwo"
              ref="loanTwo"
              class="flexbox"
            >
              <div class="row q-col-gutter-md" style="margin-top: 10px">
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Purchase Amount</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanTwo.purchase_amount"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Purchase Amount.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Period</span>
                  <q-input
                    dense
                    type="number"
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanTwo.length"
                    :rules="[val => (val !== null && val !== '' && val > 0) || 'Please type Period.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Depreciation Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    step="0.1"
                    lazy-rules
                    v-model.number="loanTwo.monthly_depreciation_rate"
                    :rules="[val => val > 0 || val === null || val === '' || 'Invalid type Monthly Depreciation Rate']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Monthly Interest Rate (%)</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    step="0.1"
                    hide-bottom-space
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanTwo.monthly_interest_rate"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type monthly interest.',
                      val => val >= 0 || 'Invalid type Monthly Interest'
                    ]"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Down Payment</span>
                  <q-input
                    type="number"
                    dense
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    lazy-rules
                    v-model.number="loanTwo.down_payment"
                    :rules="[val => (val !== null && val !== '' && val >= 0) || 'Please type Down Payment.']"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Source</span>
                  <q-select
                    :disable="financeLoading"
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    dense
                    v-model="loanTwo.financing_company"
                    :options="financeCompanies"
                    :option-label="option => option.name"
                    :option-value="option => option.id"
                    lazy-rules
                    :rules="[val => (val !== null && val !== '') || 'Please select Source']"
                  />
                </div>
                <div v-if="false" class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Term</span>
                  <q-input
                    dense
                    hide-bottom-space
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    label-color="grey-7"
                    lazy-rules
                    v-model="loanTwo.term"
                  />
                </div>
                <div class="col-md-6 col-xs-12 col-lg-6 col-xl-6">
                  <span class="label-input">Start Date</span>
                  <q-input
                    dense
                    class="customTextColor"
                    outlined
                    color="grey-7"
                    hide-bottom-space
                    label-color="grey-7"
                    v-model="leaseOne.start_date"
                    mask="date"
                    :rules="['date' || 'Invalid type Start Date']"
                  >
                    <template v-slot:append>
                      <q-icon name="fas fa-calendar" class="cursor-pointer">
                        <q-popup-proxy ref="qDateProxy1" transition-show="scale" transition-hide="scale">
                          <q-date v-model="leaseOne.start_date">
                            <div class="row items-center justify-end">
                              <q-btn v-close-popup label="Close" color="primary" flat />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="col-12">
                  <div class="mt-5 flex-end q-gutter-xs">
                    <q-btn color="grey-7" @click="abort">CANCEL</q-btn>
                    <q-btn :loading="loading" label="Save" type="submit" color="positive">
                      <template v-slot:loading>
                        <q-spinner-facebook />
                      </template>
                    </q-btn>
                  </div>
                </div>
              </div>
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
      </q-card>
    </q-scroll-area>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
import SelectList from '../components/base/SelectList.vue'
import {getStatusByValue, statuses} from "@/enums";

export default {
  components: {
    SelectList
  },
  data() {
    return {
      financeLoading: false,
      selectedFinanceFilter: { label: 'Assumption', value: 'lease_one' },
      financeFilters: [
        { label: 'Assumption', value: 'lease_one' },
        { label: 'Lease', value: 'lease_two' },
        { label: 'Flooring', value: 'loan_one' },
        { label: 'Finance', value: 'loan_two' }
      ],
      financeCompanies: [],
      leaseOne: {
        type: 'lease',
        purchase_amount: null,
        length: null,
        monthly_depreciation: null,
        monthly_payment: null,
        financing_company: null,
        start_date: new Date().toISOString().slice(0, 10),
        term: null
      },
      leaseTwo: {
        type: 'lease',
        purchase_amount: null,
        length: null,
        monthly_depreciation_rate: null,
        monthly_interest_rate: null,
        financing_company: null,
        start_date: new Date().toISOString().slice(0, 10),
        term: null
      },
      loanOne: {
        type: 'loan',
        financing_company: null,
        start_date: new Date().toISOString().slice(0, 10),
        length: null,
        purchase_amount: null,
        monthly_depreciation_rate: null,
        monthly_interest_rate: null,
        monthly_payment: null,
        is_least_payment: true,
        term: null,
        down_payment: null
      },
      loanTwo: {
        type: 'loan',
        financing_company: null,
        purchase_amount: null,
        start_date: new Date().toISOString().slice(0, 10),
        length: null,
        monthly_depreciation_rate: null,
        monthly_interest_rate: null,
        down_payment: null
        //term: null,
      },
      openGroups: false,
      openClass: false,
      tab: 'edit',
      innerLoading: false,
      loading: false,
      company: {},
      classes: [],
      selectedClass: null,
      manheimResult: false,
      vin: '',
      unit: '',
      brand: null,
      model: null,
      modelDetail: null,
      color: '',
      segment: '',
      conditions: [
        { name: 'Above', val: 'excellent' },
        { name: 'Average', val: 'good' },
        { name: 'Below', val: 'fair' }
      ],
      condition: { name: 'Good', val: 'good' },
      status: statuses[0],
      modelYear: '',
      models: [],
      modelDetails: [],
      brands: [],
      mileage: '',
      group: '',
      location: {},
      localTags: [],
      result: false,
      locations: [],
      in_service_date: null
    }
  },
  methods: {
    statuses() {
      return statuses
    },
    async getCompanyVehicleClasses() {
        try {
            const response = await axios.get('/company-vehicle-classes', {
                params: {
                    company_id: this.company.id
                }
            });
            this.classes = response.data.data.map(item => {
                return {
                    label: item.name,
                    value: item.id
                }
            });
        } catch (e) {
            console.log(e);
        }
    },
    selectGroup(group) {
      this.group = group
      this.openGroups = false
    },
    selectClass(cls) {
      this.segment = cls
      this.openClass = false
    },
    async getFinanceCompanies() {
      try {
        const {
          data: { data }
        } = await axios.get('financing-companies')
        this.financeCompanies = data
      } catch (error) {}
    },
    async onSubmitLoanTwo() {
      try {
        this.financeLoading = true
        const body = {
          vehicle: this.selectedVehicle.id,
          ...this.loanTwo,
          financing_company: this.loanTwo.financing_company.id,
          start_date: this.loanTwo.start_date ? this.loanTwo.start_date.replaceAll('/', '-') : null
        }
        await axios.put('vehicle-finance', body)
        this.financeLoading = false
        this.resetter()
        this.edit = false
        this.$q.notify({
          message: 'Successfully',
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (error) {
        this.financeLoading = false
        const errors = error.response?.data?.errors || 'Something went wrong'

        let message = ''

        function errorHandler(obj) {
          try {
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key]
                if (Array.isArray(element)) {
                  message = element[0]
                } else if (typeof element === 'object') {
                  errorHandler(element)
                } else {
                  message = element
                }
              }
            }
          } catch (error) {
            message = 'Something went wrong'
          }
        }

        errorHandler(errors)

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async onSubmitLoanOne() {
      try {
        this.financeLoading = true
        const body = {
          vehicle: this.selectedVehicle.id,
          ...this.loanOne,
          financing_company: this.loanOne.financing_company.id,
          start_date: this.loanOne.start_date ? this.loanOne.start_date.replaceAll('/', '-') : null
        }
        await axios.put('vehicle-finance', body)
        this.financeLoading = false
        this.edit = false
        this.resetter()
        this.$q.notify({
          message: 'Successfully',
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (error) {
        this.financeLoading = false
        const errors = error.response?.data?.errors || 'Something went wrong'

        let message = ''

        function errorHandler(obj) {
          try {
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key]
                if (Array.isArray(element)) {
                  message = element[0]
                } else if (typeof element === 'object') {
                  errorHandler(element)
                } else {
                  message = element
                }
              }
            }
          } catch (error) {
            message = 'Something went wrong'
          }
        }

        errorHandler(errors)

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async onSubmitLeaseOne() {
      try {
        this.financeLoading = true
        const body = {
          vehicle: this.selectedVehicle.id,
          ...this.leaseOne,
          financing_company: this.leaseOne.financing_company.id,
          start_date: this.leaseOne.start_date ? this.leaseOne.start_date.replaceAll('/', '-') : null
        }
        await axios.put('vehicle-finance', body)
        this.resetter()
        this.edit = false
        this.financeLoading = false
        this.$q.notify({
          message: 'Successfully',
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (error) {
        this.financeLoading = false
        const errors = error.response?.data?.errors || 'Something went wrong'

        let message = ''

        function errorHandler(obj) {
          try {
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key]
                if (Array.isArray(element)) {
                  message = element[0]
                } else if (typeof element === 'object') {
                  errorHandler(element)
                } else {
                  message = element
                }
              }
            }
          } catch (error) {
            message = 'Something went wrong'
          }
        }

        errorHandler(errors)

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async onSubmitLeaseTwo() {
      try {
        this.financeLoading = true
        const body = {
          vehicle: this.selectedVehicle.id,
          ...this.leaseTwo,
          financing_company: this.leaseTwo.financing_company.id,
          start_date: this.leaseTwo.start_date ? this.leaseTwo.start_date.replaceAll('/', '-') : null
        }
        await axios.put('vehicle-finance', body)
        this.resetter()
        this.edit = false
        this.financeLoading = false
        this.$q.notify({
          message: 'Successfully',
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (error) {
        this.financeLoading = false
        const errors = error.response?.data?.errors || 'Something went wrong'

        let message = ''

        function errorHandler(obj) {
          try {
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key]
                if (Array.isArray(element)) {
                  message = element[0]
                } else if (typeof element === 'object') {
                  errorHandler(element)
                } else {
                  message = element
                }
              }
            }
          } catch (error) {
            message = 'Something went wrong'
          }
        }

        errorHandler(errors)

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      }
    },
    async getFinanceData(id) {
      try {
        await this.getFinanceCompanies()
        const {
          data: { data }
        } = await axios.get(`vehicle-finance/${id}`)
        const type = `${data.type}_${data.method}`
        this.selectedFinanceFilter = this.financeFilters.find(item => item.value === type) || this.financeFilters[0]
        this.loanOne.financing_company = this.financeCompanies.find(item => item.name === 'Assumption')
        this.loanTwo.financing_company = this.financeCompanies.find(item => item.name === 'Assumption')
        this.leaseOne.financing_company = this.financeCompanies.find(item => item.name === 'Assumption')
        this.leaseTwo.financing_company = this.financeCompanies.find(item => item.name === 'Assumption')
        if (type === 'loan_one') {
          this.loanOne = {
            type: data.type,
            financing_company: data.financing_company || null,
            length: Number(data.length),
            purchase_amount: Number(data.purchase_amount),
            monthly_depreciation_rate: Number(data.monthly_depreciation_rate),
            monthly_interest_rate: Number(data.monthly_interest_rate),
            monthly_payment: Number(data.monthly_payment),
            is_least_payment: data.is_least_payment || false,
            down_payment: Number(data.down_payment),
            term: data.term,
            start_date: data.start_date ? data.start_date.replaceAll('-', '/') : null
          }
        } else if (type === 'loan_two') {
          this.loanTwo = {
            type: data.type,
            financing_company: data.financing_company || null,
            length: Number(data.length),
            purchase_amount: Number(data.purchase_amount),
            monthly_depreciation_rate: Number(data.monthly_depreciation_rate),
            monthly_interest_rate: Number(data.monthly_interest_rate),
            down_payment: Number(data.down_payment),
            term: data.term,
            start_date: data.start_date ? data.start_date.replaceAll('-', '/') : null
          }
        } else if (type === 'lease_one') {
          this.leaseOne = {
            type: data.type,
            financing_company: data.financing_company || null,
            length: Number(data.length),
            purchase_amount: data.purchase_amount,
            monthly_payment: Number(data.monthly_payment),
            monthly_depreciation: Number(data.monthly_depreciation),
            start_date: data.start_date ? data.start_date.replaceAll('-', '/') : null,
            term: data.term
          }
        } else if (type === 'lease_two') {
          this.leaseTwo = {
            type: data.type,
            financing_company: data.financing_company || null,
            length: Number(data.length),
            purchase_amount: Number(data.purchase_amount),
            monthly_depreciation_rate: Number(data.monthly_depreciation_rate),
            monthly_interest_rate: Number(data.monthly_interest_rate),
            term: data.term,
            start_date: data.start_date ? data.start_date.replaceAll('-', '/') : null
          }
        }
      } catch (error) {}
    },
    yearChangeHandler() {
      this.resetKeys(['brand', 'model', 'modelDetail'])
    },
    brandChangeHandler(e) {
      this.resetKeys(['model', 'modelDetail'])
      this.getModelViaVIN(this.modelYear, e)
    },
    modelChangeHandler(e) {
      this.resetKeys(['modelDetail'])
      this.getModelDetailViaVIN(this.modelYear, this.brand, e)
    },
    resetKeys(keys) {
      const self = this
      keys.forEach(key => {
        self[key] = null
      })
    },
    async getBrandViaVIN(year) {
      try {
        const { data } = await axios.get(`vehicle-brands-by-year/${year}`)
        this.brands = data.data
        this.brand && this.getModelViaVIN(year, this.brand)
      } catch (error) {}
    },
    async getModelViaVIN(year, brand) {
      try {
        const { data } = await axios.get(`vehicle-models-by-year/${year}/${brand}`)
        this.models = data.data
        this.model && this.getModelDetailViaVIN(year, brand, this.model)
      } catch (error) {}
    },
    async getModelDetailViaVIN(year, brand, model) {
      try {
        const { data } = await axios.get(`vehicle-model-details-by-year/${year}/${brand}/${model}`)
        this.modelDetails = data.data
      } catch (error) {}
    },
    async handleVin(e) {
      if (e.target.value.length !== 17) return
      this.innerLoading = true
      try {
        const body = {
          vin: e.target.value,
          region: this.location.region
        }
        const {
          data: { data }
        } = await axios.post('queries/manheim-vehicle-provision', body)
        this.manheimResult = true
        this.brand = data.brand
        this.model = data.model
        this.modelDetail = data.model_detail
        this.modelYear = data.model_year
      } catch (error) {
        const errors = error.response?.data?.errors

        let message = ''

        function errorHandler(obj) {
          try {
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key]
                if (Array.isArray(element)) {
                  message = element[0]
                } else if (typeof element === 'object') {
                  errorHandler(element)
                } else {
                  message = element
                }
              }
            }
          } catch (error) {
            message = 'Something went wrong'
          }
        }
        if (error.response?.data?.code === 404) {
          message = error.response?.data?.message
        } else if (error.response?.data?.code === 422) {
          errorHandler(errors)
        }

        const notFound = error.response?.data?.code === 500
        if (notFound) {
          this.manheimResult = false
          this.brand = ''
          this.model = ''
          this.modelDetail = ''
          this.modelYear = ''
        }
        this.$q.notify({
          message: notFound ? 'Can not find vehicles please contiune manual entrying' : message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
        this.result = false
      } finally {
        this.result = false
        this.innerLoading = false
      }
    },
    extraCancel() {
      this.resetter()
      this.operation = false
    },
    async getLocationByCompanyId(id) {
      if (!id) return true
      const params = { company_id: id }
      const { data } = await axios.get(`locations`, { params })
      this.locations = data.data || []
    },
    async getDetails(modelId) {
      const { data } = await axios.get('vehicle-model', {
        params: { model_id: modelId }
      })
      this.modelDetails = data.data
    },
    async getModels(brandId) {
      const { data } = await axios.get('vehicle-models', {
        params: { brand_id: brandId }
      })
      this.models = data.data
    },
    dataGetter() {
      const dataHandler = {
        id: this.selectedVehicle.id,
        vin: this.vin,
        location: this.location,
        unit: this.unit,
        brand: this.brand,
        model: this.model,
        model_detail: this.modelDetail,
        color: this.color,
        class_name: this.segment,
        company: this.selectedVehicle.company,
        model_year: this.modelYear,
        group_name: this.group.name,
        tags: this.localTags,
        condition: this.condition.val,
        status: this.status.value,
        in_service_date: this.in_service_date
      }
      return { dataHandler }
    },
    async onSubmit() {
      try {
        this.loading = true
        const { body } = await this.bodyHandler()
        const { data } = await axios.patch(`vehicle/${this.selectedVehicle.id}`, body)
        const { dataHandler } = await this.dataGetter()
        console.log(dataHandler)
        this.$store.commit('vehicle/EDIT_VEHICLE', dataHandler)
        this.$root.$emit('reRequest', dataHandler.id)
        this.$q.notify({
          message: 'Successfully edited',
          timeout: 2500,
          progress: true,
          type: 'positive'
        })
        this.edit = false
      } catch (error) {
        const errors = error.response?.data?.errors || 'Something went wrong'

        let message = ''

        function errorHandler(obj) {
          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const element = obj[key]
              if (Array.isArray(element)) {
                message = element[0]
              } else if (typeof element === 'object') {
                errorHandler(element)
              } else {
                message = element
              }
            }
          }
        }

        if (error.response?.data?.code === 400 || error.response?.data?.code === 404) {
          message = error.response?.data?.message
        } else if (error.response?.data?.code === 422) {
          errorHandler(errors)
        }

        this.$q.notify({
          message,
          timeout: 3000,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
      }
    },
    bodyHandler() {
      const fullTime = this.in_service_date.replaceAll('/', '-').split('-')
      const formatdate = `${fullTime[2]}-${fullTime[0]}-${fullTime[1]}`
      const body = {
        vin: this.vin,
        unit: this.unit,
        condition: this.condition.val,
        location: this.location.id,
        company: this.company.id,
        mileage: +this.mileage,
        in_service_date: this.in_service_date ? formatdate : null,
        status: this.status.value
      }
      if (this.localTags) body.tags = this.localTags.map(item => item.id)
      if (this.brand) body.brand_name = this.brand
      if (this.model) body.model_name = this.model
      if (this.modelDetail) body.model_detail_name = this.modelDetail
      if (this.selectedClass) body.company_class = this.selectedClass.value
      if (this.modelYear) body.model_year = this.modelYear
      if (this.color) body.color = this.color
      return { body }
    },
    async getCompanies() {
      const { data } = await axios.get('companies')
      this.companies = data.data
    },
    resetter() {
      this.leaseOne = {
        type: 'lease',
        purchase_amount: null,
        length: null,
        monthly_depreciation: null,
        monthly_payment: null,
        financing_company: null,
        start_date: new Date().toISOString().slice(0, 10),
        term: null
      }
      this.leaseTwo = {
        type: 'lease',
        purchase_amount: null,
        length: null,
        monthly_depreciation_rate: null,
        monthly_interest_rate: null,
        financing_company: null,
        start_date: new Date().toISOString().slice(0, 10),
        term: null
      }
      this.loanOne = {
        type: 'loan',
        financing_company: null,
        start_date: new Date().toISOString().slice(0, 10),
        length: null,
        purchase_amount: null,
        monthly_depreciation_rate: null,
        monthly_interest_rate: null,
        monthly_payment: null,
        is_least_payment: true,
        term: null,
        down_payment: null
      }
      this.loanTwo = {
        type: 'loan',
        financing_company: null,
        purchase_amount: null,
        start_date: new Date().toISOString().slice(0, 10),
        length: null,
        monthly_depreciation_rate: null,
        monthly_interest_rate: null,
        down_payment: null,
        term: null
      }
      this.result = false
      this.loading = false
      this.company = {}
      this.vin = ''
      this.unit = ''
      this.brand = {}
      this.model = {}
      this.mileage = ''
      this.modelDetail = {}
      this.color = ''
      this.segment = ''
      this.modelYear = ''
      this.model = {}
      this.detail = {}
      this.group = ''
      this.in_service_date = null
    },
    async abort() {
      await this.resetter()
      this.edit = false
    }
  },
  computed: {
    selectedVehicle() {
      // get() {
      //   return this.$store.state.vehicle.selectedVehicle;
      // },
      // set(val) {
      //   this.$store.commit("vehicle/SET_SELECTED_VEHICLE", val);
      // },
      return this.$store.getters['vehicle/getSelectedVehicle']
    },
    tags: {
      get() {
        return this.$store.state.tag.tags
      },
      set(val) {
        this.$store.commit('tag/SET_TAGS', val)
      }
    },
    groups() {
      return this.$store.state.vehicle.groups
    },
    edit: {
      get() {
        return this.$store.state.vehicle.edit
      },
      set(val) {
        this.$store.commit('vehicle/SET_EDIT', val)
      }
    },
    companies: {
      get() {
        return this.$store.state.company.companies
      },
      set(val) {
        this.$store.commit('company/SET_USER_COMPANIES', val)
      }
    }
  },
  watch: {
    modelYear: {
      handler(n) {
        n && n >= 2000 && n <= new Date().getFullYear() && this.getBrandViaVIN(n)
      },
      deep: true
    },
    company(n) {
      this.getLocationByCompanyId(n.id)
      this.getCompanyVehicleClasses()
    },
    selectedVehicle(n, o) {
      if (JSON.stringify(n) && Object.keys(n).some(s => s === 'id')) {
        if (n.in_service_date) {
          const fullTime = n.in_service_date.replaceAll('-', '/').split('/')
          this.in_service_date = `${fullTime[1]}-${fullTime[2]}-${fullTime[0]}`
        }
        if (n.tags) this.localTags = n.tags
        if (n.brand && n.brand.name) this.brand = n.brand.name
        if (n.company && n.company.name) this.company = n.company
        if (n.location && n.location.name) {
            this.location = {
                name: n.location.name,
                id: n.location.id
            }
        }
        this.vin = n.vin
        this.unit = n.unit
        if (n.model && n.model.name) this.model = n.model.name
        if (n.model_detail && n.model_detail.name) this.modelDetail = n.model_detail.name
        if (n.company_class) this.selectedClass = {
          label: n.company_class.name,
          value: n.company_class.id
        }
        if (Object.keys(n.last_mileage_record).some(s => s === 'id')) this.mileage = n.last_mileage_record.mileage
        this.color = n.color
        this.modelYear = n.model_year
        this.condition = this.conditions.filter(item => item.val === n.condition)[0]
        this.getLocationByCompanyId(this.location.id)
        n.finance?.id && this.getFinanceData(n.finance.id)
        this.status = getStatusByValue(n.status)
      }
    },
    // selectedVehicle: {
    //   deep: true,
    //   immediate: true,
    //   handler(n, o) {
    //     console.log(n);
    //     this.tab = "edit";
    //     if (JSON.stringify(n) && Object.keys(n).some((s) => s === "id")) {
    //       if (n.in_service_date) {
    //         const fullTime = n.in_service_date.replaceAll("-", "/").split("/");
    //         const formatdate = `${fullTime[1]}-${fullTime[2]}-${fullTime[0]}`;
    //         this.in_service_date = formatdate;
    //       }
    //       if (n.tags) this.localTags = n.tags;
    //       if (n.brand && n.brand.name) this.brand = n.brand.name;
    //       if (n.company && n.company.name) this.company = n.company;
    //       if (n.location && n.location.name) this.location = n.location;
    //       this.vin = n.vin;
    //       this.unit = n.unit;
    //       if (n.model && n.model.name) this.model = n.model.name;
    //       if (n.model_detail && n.model_detail.name)
    //         this.modelDetail = n.model_detail.name;
    //       if (n.class_name) this.segment = n.class_name;
    //       if (n.group_name) this.group = n.group_name;
    //       if (Object.keys(n.last_mileage_record).some((s) => s === "id"))
    //         this.mileage = n.last_mileage_record.mileage;
    //       this.color = n.color;
    //       this.modelYear = n.model_year;
    //       this.condition = this.conditions.filter(
    //         (item) => item.val === n.condition
    //       )[0];
    //       this.getLocationByCompanyId(this.location.id);
    //       n.finance?.id && this.getFinanceData(n.finance.id);
    //     }
    //   },
    // },
    selectedFinanceFilter: {
      deep: true,
      handler(n) {
        if (this.$refs.loanTwo) {
          this.$refs.loanTwo.resetValidation()
        }
        if (this.$refs.loanOne) {
          this.$refs.loanOne.resetValidation()
        }
        if (this.$refs.leaseOne) {
          this.$refs.leaseOne.resetValidation()
        }
        if (this.$refs.leaseTwo) {
          this.$refs.leaseTwo.resetValidation()
        }
      }
    }
  }
}
</script>
